// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instant-text-button{width:2rem;height:2rem;border-width:1px;border-style:solid;--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity));margin-right:.5rem}", ""]);
// Exports
module.exports = exports;
